module.exports = __webpack_public_path__ + "img/1-l@2x.e1e4c379.jpg";